import React, { useContext, useEffect, useState } from "react";
import NotificationBar from "./NotificationBar";
import NotificationContent from "./Notifications";
import axios from "../../axios/axios";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../components/PageLoader";
import { setAdminNotificationCount } from "../../redux/slice/adminNotificationSlice";
import { useNavigate } from "react-router-dom";
import { NotificationContext } from "../DashboardLayout";
import { setNotificationFilter } from "../../redux/slice/adminNotificationSlice";
import useViewportWidth from '../../utils/useViewportWidth';
import { AuthenticationContext } from "../../App";
import { CommomPermission } from "../../common/Constants";
import LoaderImage from "../../images/ohhto-loading.gif";


const AddPropertyToArray = (data) => {
  return data.map((item) => ({
    ...item,
    label: item?.name,
    key: item?.id,
  }));
};

const NotificationLayout = () => {
  const viewportWidth = useViewportWidth();
  const { authData } = useContext(AuthenticationContext);
  const FlooringPErmission = authData?.permissions?.filter((it) => it.name === "flooring")?.map((itx) => itx?.submodules).flat()?.filter((its) => its?.name === "flooring-cases");
  const FloorPagePErmission = FlooringPErmission !== undefined && FlooringPErmission?.length > 0 ? FlooringPErmission[0] : CommomPermission;

  const [notfBar, setNotfBar] = useState(false);
  useEffect(() => {
    setNotfBar(viewportWidth <= 1180);
  }, [viewportWidth]);

  const accessToken = localStorage.getItem("agentModuleToken");
  const filters = useSelector(
    (state) => state?.adminNotificationFilter.notificationFilter
  );
  console.log("FILETERS", filters);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { notificationCount, setNotificationCount } =
    useContext(NotificationContext);
  const settings = useSelector((state) => state.settings);
  const [loading, setLoading] = useState(false);
  const [adminNotifications, setAminNotifications] = useState([]);
  const [totalAdminNotifications, setTotalAdminNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState({});
  const [notificationTabs, setNotificationsTab] = useState([]);
  // const [notfBar,setNotfBar]=useState(false);
  const [applyFilters, setApplyFilters] = useState(
    Object?.keys(filters)?.length > 0
      ? filters
      : {
        productType: "",
        sortBy: "month",
      }
  );
  const [activeTab, setActiveTab] = useState({});

  console.log("APPLY", applyFilters);

  const OnNotifcationRead = async (type, groupby) => {
    let res = await axios.put(
      `/notification/status/update/${groupby}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  };

  const setInitialNotification = (adminNotification) => {
    if (adminNotification?.length > 0) {
      const temp = adminNotification?.filter(
        (it) => it?.notification_type !== "application"
      );
      if (adminNotification[0]?.notification_type === "application") {
        let unReadNotification = adminNotification?.filter(
          (it) => it?.status === 0
        )?.length;
        setNotificationCount(unReadNotification);
        dispatch(setAdminNotificationCount(unReadNotification));
      } else {
        let unReadNotification = adminNotification
          ?.filter((id, index) => index !== 0)
          ?.filter((it) => it?.status === 0)?.length;
        setNotificationCount(unReadNotification);
        dispatch(setAdminNotificationCount(unReadNotification));
      }

      if (temp?.length > 0) {
        setSelectedNotification(temp[0]);
        const newState = adminNotification.map((obj) => {
          if (obj.index === temp[0]?.index) {
            return { ...obj, status: 1 };
          }
          return obj;
        });
        setAminNotifications(newState);
        OnNotifcationRead("intial", temp[0]?.groupby);
      }
    } else {
      setNotificationCount(0);
      setSelectedNotification({});
      dispatch(setAdminNotificationCount(0));
    }
  };

  const GetAdminNotifications = async () => {
    setLoading(true);
    const { data } = await axios.post(`/notification/list`, applyFilters, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    setAminNotifications(data?.data);
    setInitialNotification(data?.data);
    setTotalAdminNotifications(data?.data);
    setLoading(false);
  };

  const onSearch = (key) => {
    let temp = totalAdminNotifications.filter((item) => {
      return item?.name?.toLowerCase()?.includes(key?.toLowerCase());
    });

    if (temp !== undefined && temp !== null) {
      setAminNotifications(temp);
    }
  };

  const OnNotificationSelecct = (id) => {
    console.log(id);
    let temp = adminNotifications?.filter((it) => it?.index === id);
    console.log(temp);
    const newState = adminNotifications.map((obj) => {
      if (obj.index === id) {
        return { ...obj, status: 1 };
      }
      return obj;
    });
    setAminNotifications(newState);
    setNotificationCount(newState?.filter((it) => it?.status === 0)?.length);
    if (temp?.length > 0 && temp[0]?.notification_type !== "application") {
      setSelectedNotification(temp[0]);
      temp[0]?.status !== 1 && OnNotifcationRead("click", temp[0]?.groupby);
    } else {
      temp[0]?.status !== 1 && OnNotifcationRead("click", temp[0]?.groupby);
      setTimeout(() => {
        console.log("APPLICATION", temp[0]);
        navigate("/case-detail", { state: { Id: temp[0]?.id, pagePermission: FloorPagePErmission } });
      }, 500);
    }
  };

  const onFilterChange = (type, value) => {
    setApplyFilters({
      ...applyFilters,
      [type]: value,
    });
    dispatch(
      setNotificationFilter({
        ...applyFilters,
        [type]: value,
      })
    );
  };

  useEffect(() => {
    if (settings?.loanProviderTypes?.length > 0) {
      setNotificationsTab(AddPropertyToArray(settings?.loanProviderTypes));
      // setApplyFilters({
      //   ...applyFilters,
      //   productType: "",
      //   sortBy: "week",
      // });
    }
  }, []);

  useEffect(() => { }, [adminNotifications]);

  useEffect(() => {
    GetAdminNotifications();
  }, [applyFilters]);

  return (
    <div className="flex w-full">
      {loading && (
        <div className="absolute z-50 left-0 top-0 w-full h-full  flex items-center justify-center">
          <img src={LoaderImage} className="w-24 h-24" />
        </div>
      )}
      <NotificationBar
        adminNotifications={adminNotifications}
        OnNotificationSelecct={OnNotificationSelecct}
        notificationTabs={notificationTabs}
        onFilterChange={onFilterChange}
        onSearch={onSearch}
        loading={loading}
        selectedNotification={selectedNotification}
        reload={GetAdminNotifications}
        applyFilters={applyFilters}
        notfBar={notfBar}
        notfBarClose={() => setNotfBar(false)}
      />
      <NotificationContent
        selectedNotification={selectedNotification}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        notfBar={() => setNotfBar(true)}
      />
    </div>
  );
};

export default NotificationLayout;
